import type { RequestParams } from '../requests/http-client';
import { HttpClient } from '../requests/http-client';
import type { BaseErrorResponse, HealthCheckRes } from './data-contracts';


export default function useApp() {
  class App<SecurityDataType = unknown> extends HttpClient<SecurityDataType> {
    /**
     * No description
     *
     * @tags Application
     * @name HealthCheckControllerHealthCheck
     * @summary Health check application
     * @request GET:/cs2/app/health-check
     * @response `200` `HealthCheckRes`
     * @response `400` `BaseErrorResponse`
     */
    healthCheckControllerHealthCheck = (params: RequestParams = {}) =>
      this.request<HealthCheckRes, BaseErrorResponse>({
        path: '/cs2/app/health-check',
        method: 'GET',
        format: 'json',
        ...params,
      });
  }

  return new App();
}
